import { render, staticRenderFns } from "./ApprovalCertification.vue?vue&type=template&id=0a0a87da"
import script from "./ApprovalCertification.vue?vue&type=script&lang=js"
export * from "./ApprovalCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0a87da')) {
      api.createRecord('0a0a87da', component.options)
    } else {
      api.reload('0a0a87da', component.options)
    }
    module.hot.accept("./ApprovalCertification.vue?vue&type=template&id=0a0a87da", function () {
      api.rerender('0a0a87da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ApprovalCertification.vue"
export default component.exports